export default "__VITE_PUBLIC_ASSET__ce97a917__"